import { BaseQuantity } from "../../interface/functionalityInterface";
// Base quantity
// coherent SI unit is s

export const Time: BaseQuantity = {
  id: "001time",
  name: "time",
  type: "numeric",
  value: "",
  symbol: "t",
  baseUnit: "s",
  selectedUnit: "s",
  units: [
    { name: "ms", fromConst: 1 / 1000, toConst: 1000 },
    { name: "s", fromConst: 1, toConst: 1 },
    { name: "min", fromConst: 60, toConst: 1 / 60 },
    { name: "h", fromConst: 60 * 60, toConst: 1 / 60 / 60 },
    { name: "day", fromConst: 60 * 60 * 24, toConst: 1 / 60 / 60 / 24 },
  ],
};
